module.exports = __webpack_public_path__ + "fonts/Inter-Black.09f4068.woff2";